import axios from "axios";
import { sha256 } from 'js-sha256';


export const changePassword = async (currentPassword, newPassword) => {
    const url = "https://pswupdate.cvis.videri.ai/user/password"
    
    const username = localStorage.getItem("username")
    const password = currentPassword
    var hash = sha256.create();
    hash.update(password);
    const hpassword = hash.hex();

    const payload = {
        "username": username,
        "current_password": hpassword,
        "new_password": newPassword
    }
    console.warn(payload)
    try {
        const result = await axios.put(url, payload)
        console.warn(result)
            if (result.status === 200) {
        return true
    } else {

        return false
    }
    
    } catch (error) {

        console.warn("Error changing password:", error);
        return false
    }

}